import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Layout from "./components/layout/Layout";
import HomePage from "./pages/HomePage";
import AboutPage from "./pages/AboutPage";
import CareersPage from "./pages/CareersPage";
import ContactPage from "./pages/ContactPage";
import CaseStudiesPage from "./pages/CaseStudiesPage";
import ServicesPage from "./pages/ServicesPage";
import AdminDashboard from "./pages/AdminDashboard";

function App() {
  return (
    <BrowserRouter>
      <Routes>
        {/* Admin Route - No Layout */}
        <Route path="/admin" element={<AdminDashboard />} />
        
        {/* Public Routes with Layout */}
        <Route element={<Layout><HomePage /></Layout>} path="/" />
        <Route element={<Layout><AboutPage /></Layout>} path="/about" />
        <Route element={<Layout><CareersPage /></Layout>} path="/careers" />
        <Route element={<Layout><ContactPage /></Layout>} path="/contact" />
        <Route element={<Layout><CaseStudiesPage /></Layout>} path="/case-studies" />
        <Route element={<Layout><ServicesPage /></Layout>} path="/services/:serviceId" />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
